import { captureException, initSentry } from './sentry';

export type AnalyticsOperation = 'report' | 'search' | 'export' | 'chart';

/** Only operation and HTTP status are recorded; no campaign data or queries. */
export function reportAnalyticsFailure(operation: AnalyticsOperation, status?: number): void {
  void initSentry().then(() => captureException(new Error(`Analytics ${operation} failed`), {
    tags: { surface: 'analytics', operation, ...(status ? { http_status: status } : {}) },
    fingerprint: ['analytics', operation, String(status || 'network')],
  })).catch(() => { /* Telemetry must never break the report. */ });
}
